import { useEffect, useState } from "react";

export const useParentWindowWidth = () => {
  const [parentWidth, setParentWidth] = useState<number | null>(null);
  const [isMobileParent, setIsMobileParent] = useState(false);

  useEffect(() => {
    const isInIframe = window.self !== window.top;
    if (!isInIframe) return;

    const updateParentWidth = () => {
      try {
        const width = window.parent.innerWidth;
        setParentWidth(width);
        setIsMobileParent(width < 480);
      } catch (error) {
        const iframeWidth = window.innerWidth;
        setParentWidth(iframeWidth);
        setIsMobileParent(iframeWidth !== 400);
      }
    };

    updateParentWidth();

    const handleResize = () => updateParentWidth();

    try {
      window.parent.addEventListener("resize", handleResize);
      return () => window.parent.removeEventListener("resize", handleResize);
    } catch (error) {
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  return { parentWidth, isMobileParent };
};
